var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M11.7002 5.61255H7.80646H4.30021C3.70021 5.61255 3.40021 6.33755 3.82521 6.76255L7.06271 10C7.58146 10.5188 8.42521 10.5188 8.94396 10L10.1752 8.7688L12.1815 6.76255C12.6002 6.33755 12.3002 5.61255 11.7002 5.61255Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }